import { Select, Button } from "antd";
import { Phone } from "lucide-react";
import { useState } from "react";

type AgentStatus = 'Sẵn sàng' | 'Tạm nghỉ' | 'Ngoại tuyến';

const AGENT_DOT: Record<AgentStatus, string> = {
    'Sẵn sàng': '#2E7D4F',
    'Tạm nghỉ': '#C77700',
    'Ngoại tuyến': '#999999',
};


export default function SoftBar() {
    const [agentStatus, setAgentStatus] = useState<AgentStatus>("Sẵn sàng");
    return (
        <div className="fixed bottom-3 left-3 right-3 z-50 flex flex-wrap items-center gap-2 rounded-lg bg-[#16406b] px-3 py-2 text-sm text-white shadow-lg dark:bg-slate-800 sm:right-auto md:left-[80px]">
            <span
                className="h-2.5 w-2.5 rounded-full"
                style={{ background: AGENT_DOT[agentStatus] }}
            />
            <b>LT-01 · Lễ tân</b>
            <Select
                size="small"
                value={agentStatus}
                onChange={(value: AgentStatus) => setAgentStatus(value)}
                className="w-28"
                options={(['Sẵn sàng', 'Tạm nghỉ', 'Ngoại tuyến'] as AgentStatus[]).map((s) => ({ value: s, label: s }))}
            />
            <span className="text-slate-300">Không có cuộc gọi</span>
            <Button size="small" icon={<Phone size={13} />} className="font-bold">
                Gọi số mới
            </Button>
        </div>
    )
}